/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_Block_Draft_Stuck_BodyInputs */



/**
* | output |
* | --- |
* | "The system could not confirm whether a draft was created. Check the accounting system first — a blind retry can create a second legal document." |
*
* @param {Partner_Detail_Block_Draft_Stuck_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_block_draft_stuck_body = /** @type {((inputs?: Partner_Detail_Block_Draft_Stuck_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Block_Draft_Stuck_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das System konnte nicht bestätigen, ob ein Entwurf erstellt wurde. Prüfen Sie zuerst die Buchhaltung — ein blinder Wiederholungsversuch kann ein zweites rechtsgültiges Dokument erzeugen.")
	return /** @type {LocalizedString} */ ("The system could not confirm whether a draft was created. Check the accounting system first — a blind retry can create a second legal document.")
});